import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TuiNotificationService } from '@taiga-ui/core';
import { AuthService } from '../../features/auth/services/auth.service';
import { notifyWarning } from '../utils/alert-helper.util';

/**
 * Listens for AuthService.sessionExpired$ and warns the user (toast only,
 * stays on page). Instantiate once at bootstrap (see App).
 */
@Injectable({ providedIn: 'root' })
export class SessionExpiryNotifierService {
  private authService = inject(AuthService);
  private alerts = inject(TuiNotificationService);

  constructor() {
    this.authService.sessionExpired$
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        notifyWarning(
          this.alerts,
          'Your session has expired. Please log in again.',
          'Session expired',
        );
      });
  }
}
